<template>
  <div class="tit-wrap">
    <h1 class="app-tit">{{ t('account_delete_title') }}</h1>
  </div>

  <div class="marker-txt-wrap">
    <div class="txt-group">
      <h2>{{ t('account_delete_sub_title_1') }}</h2>
      <ul class="marker-dot">
        <li>{{ t('account_delete_message_1') }}</li>
      </ul>
    </div>
    <div class="txt-group">
      <h2>{{ t('count_delete_sub_title_2') }}</h2>
      <ul class="marker-dot">
        <li>{{ t('account_delete_message_2') }}</li>
      </ul>
    </div>
    <div class="txt-group">
      <h2>{{ t('count_delete_sub_title_3') }}</h2>
      <ul class="marker-dot">
        <li>{{ t('account_delete_message_3') }}</li>
        <li>
          <i18n-t keypath="account_delete_button" scope="global">
            <template #button>
              <a @click="goToCustomerFaq">
                {{ t('support_center') }}
              </a>
            </template>
          </i18n-t>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
const router = useRouter();

const goToCustomerFaq = async () => {
  await router.replace({ query: { tab: '2' } });
  await router.push({ name: 'app-customer-faq' });
};
</script>

<style scoped lang="scss">
.tit-wrap {
  margin-bottom: 2.5rem;
  .app-tit {
    margin-bottom: 0.5rem;
  }
}
</style>
